module.exports = __webpack_public_path__ + "img/collection-engagementRingsCharisma.6151e27.webp";